import Meta from '@/components/common/Meta'

import StorageScholarsServicesPage from '@/v2/components/pages/landing-pages/storage-scholars-services-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/landing-pages/storage-scholars-services-page'

interface StorageScholarsServicesPageProps {}

const Page: React.FC<StorageScholarsServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.storage_scholars_services.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_scholars_services?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_scholars_services?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <StorageScholarsServicesPage />
    </>
  )
}

export default Page
